(ns ui.elements)

;; Typically the main title or headline for a page or major section.
;; Each page usually has just one H1 (for SEO and accessibility).
;; Example: The title of a blog post, product page, or documentation page.
(def h1
  ["text-4xl" "font-bold" "text-gray-900" "leading-tight"])

;; Use H2 for key sections or major topics under your main heading.
;; This helps readers (and search engines) quickly see how you’ve structured your content.
;; Example: A “Features” heading in a product page, or “Introduction” and “Background”
(def h2
  ["text-2xl" "font-semibold" "text-gray-800"])

;; Nest H3 headings under a relevant H2.
;; Helps break down a larger H2 topic into more specific subtopics.
;; Example: Under “Features” (H2), you might list “Feature A” and “Feature B” as H3 headings.
(def h3
  ["text-xl" "font-semibold" "text-gray-800"])

;; Use H4 if you need yet another level of detail under an H3.
;; Not every project requires this depth, but it’s available for complex outlines.
;; Example: Under “Feature A” (H3), you could have “Configuration Options” (H4) if it has several details.
(def h4
  ["text-lg" "font-semibold" "text-gray-800"])

;; default text paragraph
(def p
  ["text-gray-600" "leading-relaxed"])

(def p-sm
  ["text-gray-700" "leading-relaxed" "text-sm"])

(def panel
  ["shadow-sm"
   "rounded-lg"
   "bg-white"
   "p-6"])
